import React, { useId, useState } from "react";
import InlinePresentationMedia from "./InlinePresentationMedia";

export function groupLayoutOptions(options) {
  const groups = new Map();
  for (const option of options) {
    const room = (option.room_type || "").trim();
    const category = /ticari|ofis|dükkan|mağaza/i.test(`${room} ${option.unit_type || ""}`) ? "Ticari" : room || option.unit_type || "Diğer";
    if (!groups.has(category)) groups.set(category, { name: category, types: [], images: [] });
    const group = groups.get(category);
    let type = (option.layout_type || "").trim();
    if (room && type.toLocaleLowerCase("tr").startsWith(room.toLocaleLowerCase("tr"))) type = type.slice(room.length).replace(/^[\s·:–-]+/, "");
    type = type || "Standart tip";
    let entry = group.types.find(item => item.name === type);
    if (!entry) { entry = { name: type, plans: [] }; group.types.push(entry); }
    if (option.plan_url && !entry.plans.includes(option.plan_url)) entry.plans.push(option.plan_url);
    for (const url of option.image_urls || []) if (url && !group.images.includes(url)) group.images.push(url);
  }
  return [...groups.values()].sort((a, b) => (a.name === "Ticari") - (b.name === "Ticari") || a.name.localeCompare(b.name, "tr", { numeric: true }));
}

export default function ProjectLayoutCatalogue({ options = [] }) {
  const groups = groupLayoutOptions(options);
  const [selected, setSelected] = useState("");
  const prefix = useId();
  const active = groups.find(group => group.name === selected) || groups[0];
  if (!active) return null;
  const index = groups.indexOf(active);
  const chooseByKey = event => {
    let next;
    if (event.key === "ArrowRight") next = (index + 1) % groups.length;
    if (event.key === "ArrowLeft") next = (index - 1 + groups.length) % groups.length;
    if (event.key === "Home") next = 0;
    if (event.key === "End") next = groups.length - 1;
    if (next !== undefined) {
      event.preventDefault();
      setSelected(groups[next].name);
      event.currentTarget.parentElement.children[next].focus();
    }
  };
  return <section className="max-w-7xl mx-auto px-6 pb-10" data-testid="public-layout-catalogue">
    <h2 className="text-2xl font-bold mb-4">Daire seçenekleri ve planlar</h2>
    <div role="tablist" aria-label="Daire kategorileri" className="flex flex-wrap gap-2 border-b border-slate-200 mb-5">
      {groups.map((group, i) => <button key={group.name} type="button" role="tab" id={`${prefix}-tab-${i}`} aria-controls={`${prefix}-panel`} aria-selected={group === active} tabIndex={group === active ? 0 : -1} onKeyDown={chooseByKey} onClick={() => setSelected(group.name)} className={`px-4 py-3 text-sm font-semibold border-b-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${group === active ? "border-slate-900 text-slate-900" : "border-transparent text-slate-500"}`}>{group.name}</button>)}
    </div>
    <div role="tabpanel" id={`${prefix}-panel`} aria-labelledby={`${prefix}-tab-${index}`} key={active.name}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        {active.types.map(type => <div key={type.name} className="min-w-0">{type.plans.length ? <InlinePresentationMedia title={type.name} urls={type.plans} collapsible={false} /> : <div className="border-t border-slate-200 py-3"><h3 className="font-semibold">{type.name}</h3><p className="text-sm text-slate-500 mt-3">Plan henüz eklenmemiş.</p></div>}</div>)}
      </div>
      <InlinePresentationMedia title={`${active.name} örnek ${active.name === "Ticari" ? "alan" : "daire"} görselleri`} urls={active.images} collapsible={false} />
    </div>
  </section>;
}
